export default "__VITE_ASSET__Blyned7n__"